import {
	getAvailablePaymentMethods,
	getPaymentData,
	postAccountCreditPayment,
	postCreditCardOnCollectionPayment,
	postEftPayment
} from "../../api/paymentController";
import { getOrderPaymentData } from "../../api/orderController";

const reportPaymentFailure = (response, fallbackMessage, {setErrorMessage, setStatusFailed}) => {
	if (!!setErrorMessage) {
		setErrorMessage(response?.message || fallbackMessage);
	}
	setStatusFailed();
};

export const fetchAvailablePaymentMethodsData = async ({
	setPaymentMethods,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let response = await getAvailablePaymentMethods();
		if (!!response?.success) {
			setPaymentMethods(response.data);
			setStatusSuccess();
		}
		else {
			setPaymentMethods([]);
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setPaymentMethods([]);
		setStatusError();
	}
};

export const fetchPaymentOrderData = async ({
	paymentType,
	setPaymentOrderInfo,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError,
	setErrorMessage
}) => {
	setStatusInProgress();
	try {
		let response = await getOrderPaymentData({type: paymentType});
		if (!!response?.success) {
			setPaymentOrderInfo(response.data);
			setStatusSuccess();
		}
		else {
			reportPaymentFailure(response, "Could not load this payment option. Please refresh the page and try again.", {setErrorMessage, setStatusFailed});
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const createAccountCreditPaymentData = async ({
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError,
	setErrorMessage
}) => {
	setStatusInProgress();
	try {
		const response = await postAccountCreditPayment();
		if (!!response?.success) {
			setStatusSuccess();
		}
		else {
			reportPaymentFailure(response, "Could not pay with account credit. Please refresh the page and try again.", {setErrorMessage, setStatusFailed});
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const createCreditCardOnCollectionPaymentData = async ({
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError,
	setErrorMessage
}) => {
	setStatusInProgress();
	try {
		const response = await postCreditCardOnCollectionPayment();
		if (!!response?.success) {
			setStatusSuccess();
		}
		else {
			reportPaymentFailure(response, "Could not select card on collection. Please refresh the page and try again.", {setErrorMessage, setStatusFailed});
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const createEftPaymentData = async ({
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError,
	setErrorMessage
}) => {
	setStatusInProgress();
	try {
		const response = await postEftPayment();
		if (!!response?.success) {
			setStatusSuccess();
		}
		else {
			reportPaymentFailure(response, "Could not pay by EFT. Please refresh the page and try again.", {setErrorMessage, setStatusFailed});
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};

export const fetchPaymentData = async ({
	paymentId,
	setPaymentData,
	setStatusInProgress,
	setStatusSuccess,
	setStatusFailed,
	setStatusError
}) => {
	setStatusInProgress();
	try {
		let response = await getPaymentData(paymentId);
		if (!!response?.success) {
			setPaymentData(response?.data);
			setStatusSuccess();
		}
		else {
			setStatusFailed();
		}
	}
	catch (error) {
		console.error(error);
		setStatusError();
	}
};
